import React, { Component } from 'react'
import { Container, Header, Segment, Form, Button } from 'semantic-ui-react'
import numeral from 'numeral'

class ReservationInfo extends Component {
    constructor(props) {
        super(props)
        this.state = { error: null, validate: false }
        this.onChange = this.onChange.bind(this)
        this.onAdditionalInfoChange = this.onAdditionalInfoChange.bind(this)
        this.onCreditCardToken = this.onCreditCardToken.bind(this)
    }

    onChange(e, data) {
        const { onChange } = this.props
        onChange(e, data)
    }

    onAdditionalInfoChange(e, data) {
        const { onAdditionalInfoChange } = this.props
        onAdditionalInfoChange(e, data)
    }

    onCreditCardToken(data) {
        console.log(data)
        // const { onChange, onSubmitReservation, parker } = this.props
        const { onSubmitReservation, parker } = this.props
        // onChange(null, { name: 'token', value: data })
        if (parker.name && parker.address && parker.city && parker.state && parker.zip && parker.mobile && parker.email) {
            onSubmitReservation(null)
        } else {
            this.setState({ validate: true })
        }
    }

    render() {
        const { event, blocks, selectedFacility, spots, parker, additionalInfo } = this.props
        const inventory = event.inventory.find((i) => i.id === selectedFacility.inventoryId)
        const { validate } = this.state
        console.log(inventory)
        const additionalFields = event && event.additionalFields ? JSON.parse(event.additionalFields) : {}

        return (
            <Container>
                <Header className="page title" as="h1" content={`Welcome ${event.name}`} />
                <Header as="h3" content="... Now complete your reservation" />
                <Segment>
                    <Header as="h4" content="Selected Parking" />
                    <div className="selected parking">
                        {blocks.map((block) => (
                            <div>
                                <div>{`${block.name} - ${spots} ${spots > 1 ? 'spots' : 'spot'} @ ${numeral(
                                    inventory.blocks.find((ib) => ib.eventBlockId === block.id).rate
                                ).format('$0,0.00')} each`}</div>
                            </div>
                        ))}
                    </div>
                    <div>
                        <strong>Total to be charged:</strong>{' '}
                        {`${numeral(blocks.reduce((acc, cur) => acc + spots * inventory.blocks.find((ib) => ib.eventBlockId === cur.id).rate, 0)).format('$0,0.00')}`}
                    </div>
                    <div className="selected facility">
                        <div>
                            {selectedFacility.name} {selectedFacility.address}
                        </div>
                        <div>Type: {selectedFacility.isLot ? 'Lot' : `Garage - ${selectedFacility.clearanceFeet}'${selectedFacility.clearanceInches}''`}</div>
                    </div>
                </Segment>
                <Segment>
                    <Header as="h4" content="Parker Information" />
                    <Form>
                        <Form.Group>
                            <Form.Input error={validate && !parker.name} width={8} label="Name" placeholder="Name" name="name" value={parker.name} onChange={this.onChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input
                                error={validate && !parker.address}
                                width={8}
                                label="Address"
                                placeholder="Address"
                                name="address"
                                value={parker.address}
                                onChange={this.onChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input width={8} label="Address 2" placeholder="Address 2" name="address2" value={parker.address2} onChange={this.onChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input error={validate && !parker.city} width={4} label="City" placeholder="City" name="city" value={parker.city} onChange={this.onChange} />
                            <Form.Input error={validate && !parker.state} width={2} label="State" placeholder="State" name="state" value={parker.state} onChange={this.onChange} />
                            <Form.Input error={validate && !parker.zip} width={2} label="Zip" placeholder="Zip" name="zip" value={parker.zip} onChange={this.onChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input
                                error={validate && !parker.mobile}
                                width={4}
                                label="Mobile Phone"
                                placeholder="Mobile Phone"
                                name="mobile"
                                value={parker.mobile}
                                onChange={this.onChange}
                            />
                            <Form.Field>
                                <p className="mobile legal">By providing a mobile number, you authorize Denison Parking to send confirmation via SMS. Regular rates apply.</p>
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Input error={validate && !parker.email} width={8} label="Email" placeholder="Email" name="email" value={parker.email} onChange={this.onChange} />
                        </Form.Group>
                    </Form>
                </Segment>
                {Object.keys(additionalFields).length > 0 ? (
                    <Segment>
                        <Header as="h4" content="Additional Information" />
                        <Form>
                            {Object.keys(additionalFields).map((f) => (
                                <Form.Group>
                                    <Form.Input
                                        width={8}
                                        label={additionalFields[f].label}
                                        placeholder={additionalFields[f].label}
                                        name={additionalFields[f].name}
                                        value={additionalInfo[additionalFields[f].name]}
                                        onChange={this.onAdditionalInfoChange}
                                    />
                                </Form.Group>
                            ))}
                        </Form>
                    </Segment>
                ) : null}
                <Segment>
                    <div className="space">
                        <Button style={{ margin: 'auto', display: 'block' }} primary onClick={this.onCreditCardToken}>
                            Review Parking Reservation
                        </Button>
                    </div>
                </Segment>
            </Container>
        )
    }
}

ReservationInfo.propTypes = {}

export default ReservationInfo
